import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { List } from "immutable";
import { ListItem } from "../list-item";

@Component({
  selector: "app-info-item-container",
  templateUrl: "./info-item.component.html",
  styleUrls: ["./info-item.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoItemComponent {
   @Input() infoItems = List<ListItem>();
   @Input() className: string;
   @Input() isSpecialHandling = false;
   @Output() enableSpecialHandling = new EventEmitter<boolean>();

   getClass(item: ListItem): string {
     return item.value === this.className ? "activeItem" : "";
  }

   itemClass(item: ListItem): string {
    let addressClass = "address-detail";
    addressClass += item.key === "Address:" ? " special-handling-address" : "";
    return addressClass;
    }

   trackByIndex(index, item) {
    return index;
  }

   isMixedRetriever(item: ListItem): boolean {
    return item.key === "Retriever:" && item.value === "Mixed";
  }

   specialHandling(value: boolean): void {
    this.enableSpecialHandling.emit(value);
  }
}
